(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.search = exports.menu = exports.fixedHeader = void 0;

// import { isMobile, setCookie, getCookie } from '../helpers';
var fixedHeader = function fixedHeader() {
  var header = document.querySelector('.header');
  window.addEventListener('scroll', function () {
    if (window.pageYOffset > 0) {
      header.classList.add('header--fixed');
    } else {
      header.classList.remove('header--fixed');
    }
  });
};

exports.fixedHeader = fixedHeader;

var menu = function menu() {
  var burger = document.querySelector('[data-burger]');
  var burgerText = document.querySelector('[data-burger-text]');
  burger.addEventListener('click', function () {
    document.body.classList.toggle('nav-active');
  });
};

exports.menu = menu;

var search = function search() {
  var searchInitButton = document.querySelector('.header__search-button');
  var searchInput = document.querySelector('[data-search-input]');
  var searchResults = document.querySelector('.search-results');
  var searchWrapper = document.querySelector('.header__search');
  var searchClear = document.querySelector('.clear-button');

  if (searchInitButton && searchInput && searchClear) {
    searchInitButton.addEventListener('click', function () {
      searchWrapper.style.display = 'flex';
    });
    searchInput.addEventListener('keyup', function (e) {
      if (searchInput.value.length > 2) {
        var ourRequest = new XMLHttpRequest();
        ourRequest.open('POST', '/wp-admin/admin-ajax.php', true);
        ourRequest.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");

        ourRequest.onreadystatechange = function () {
          if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
            if (this.response) {
              searchResults.innerHTML = this.response;
              searchWrapper.classList.add('header__search--has-items');
            }
          }
        };

        ourRequest.send("action=get_ajax_posts&search=".concat(searchInput.value));
      } else {
        searchWrapper.classList.remove('header__search--has-items');
        searchResults.innerHTML = '';
      }
    });
    searchClear.addEventListener('click', function () {
      searchWrapper.style.display = 'none';
    });
  }
};

exports.search = search;

},{}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var slider = function slider() {
  if (document.querySelector('.slider')) {
    var _slider = tns({
      container: '.slider',
      items: 1,
      mode: 'gallery',
      lazyload: false,
      slideBy: 'page',
      loop: true,
      controlsText: ['', ''],
      navContainer: '.slider-nav',
      autoplay: true,
      autoplayButtonOutput: false
    });

    var sliderNav = tns({
      container: '.slider-nav',
      items: 3,
      lazyload: false,
      loop: true,
      gutter: 30,
      slideBy: 1,
      startIndex: 1,
      nav: false,
      controls: false,
      disable: true,
      autoplay: true,
      autoplayButtonOutput: false,
      responsive: {
        1080: {
          disable: false
        }
      }
    });
    var nextButton = document.querySelector('[data-controls="next"]');
    var prevButton = document.querySelector('[data-controls="prev"]');

    if (nextButton && prevButton) {
      nextButton.addEventListener('click', function () {
        sliderNav.goTo('next');
        refreshSliders();
      });
      prevButton.addEventListener('click', function () {
        sliderNav.goTo('next');
        refreshSliders();
      });
    }

    var sliderNavItems = document.querySelectorAll('.slider-nav .tns-item');
    sliderNavItems.forEach(function (item) {
      item.addEventListener('click', function () {
        setTimeout(function () {
          var sliderInfo = _slider.getInfo();

          if (sliderInfo.index == 4) {
            sliderNav.goTo(0);
          } else {
            sliderNav.goTo(sliderInfo.index + 1);
          }

          refreshSliders();
        }, 100);
      });
    });
    var currentSliderIndexWrapper = document.querySelector('.current-slider-index');

    _slider.events.on('indexChanged', function (e) {
      currentSliderIndexWrapper.textContent = '0' + (e.index + 1);
    });

    var refreshSliders = function refreshSliders() {
      _slider.pause();

      _slider.play();

      sliderNav.pause();
      sliderNav.play();
    };
  }
};

var _default = slider;
exports.default = _default;

},{}],3:[function(require,module,exports){
"use strict";

var _header = require("./components/header");

var _slider = _interopRequireDefault(require("./components/slider"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

AOS.init({
  disable: function disable() {
    var maxWidth = 1024;
    return window.innerWidth < maxWidth;
  }
});
(0, _header.fixedHeader)();
(0, _header.menu)();
(0, _header.search)();
(0, _slider.default)();
/**
 * Scroll to top
 */

var scrollTopButton = document.querySelector('[data-scroll-top]');

if (scrollTopButton) {
  scrollTopButton.addEventListener('click', function () {
    window.scrollTo(0, 0);
  });
}

},{"./components/header":1,"./components/slider":2}]},{},[3]);
